import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'
import KeysIcon from '../images/KeysIcon.svg'
const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  min-height: 60vh;
  padding: 40px 20px;
  text-align: center;
  width: 100%;
`

const Title = styled.span`
  color: ${RADOM_COLORS.BLACK};
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
`

const Subtitle = styled.span`
  color: ${RADOM_COLORS.GRAY_DARKEST};
  font-size: 14px;
  line-height: 1.5;
  max-width: 420px;
`

interface NoPermissionProps {
  description?: string
}

const NoPermission = ({ description }: NoPermissionProps): ReactElement =>
  <Wrapper>
    <img style={{ width: '104px', height: '124px' }} src={KeysIcon as string} alt='Keys' />
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
      <Title>Sorry, you don&apos;t have permission to see that.</Title>
      <Subtitle>
        {description ?? 'Ask an organization admin to grant your role access to this page.'}
      </Subtitle>
    </div>
  </Wrapper>

export default NoPermission
